import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";
import { useNavigate } from "react-router-dom";

interface CanConfirmationModalProps extends ModalProps {
  onHide: () => void;
  handleCanSelected: () => void;
  selectedCan: any;
}

const CanConfirmationModal = ({
  onHide,
  handleCanSelected,
  selectedCan,
  ...props
}: CanConfirmationModalProps) => {
  const navigate = useNavigate();
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      backdrop="static"
      className="canConfirmationModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody">
          <div className="mb-4">
            <img
              src={selectedCan.picture}
              alt="selected can"
              width={100}
              style={{ rotate: "20deg" }}
            />
          </div>
          <div className="header" style={{ lineHeight: "1.4" }}> 
            Are you sure you want to <br/>  select this can?
          </div>

          <div className="mt-5 d-flex align-items-center gap-3 mx-5">
            <button
              className="btnPrimary w-100"
              onClick={() => handleCanSelected()}
            >
              Yes
            </button>
            <button className="btnOutline w-100" onClick={() => onHide()}>
              No
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CanConfirmationModal;
